<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div class="text item">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="用户名称：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入用户名称/手机号搜索"></el-input>
          </el-form-item>
          <el-form-item label="时间筛选：" prop="date">
            <el-date-picker
              v-model="searchForm.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="userId"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="headPicture"
            label="头像">
            <template slot-scope="scope">
              <el-image
                style="width: 40px;border-radius: 40px;"
                :src="scope.row.headPicture"
                :preview-src-list="[scope.row.headPicture]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="phone"
            label="手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            width="130"
            label="注册时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="updateUserOpenBtn(scope.row.userId)" type="text" size="small">更改上级</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 更改上级弹窗 -->
    <el-dialog
      title="更改上级"
      :visible.sync="updateUserShow"
      width="960px">
      <el-form :model="oneForm" label-width="140px">
        <el-form-item label="分销员：" prop="updateCommissionUserId">
          <el-select style="width: 420px;" v-model="oneForm.updateCommissionUserId" placeholder="请选择">
            <el-option v-for="(item,index) in updateUserList" :key="index" :label="item.nickName" :value="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import { queryUserCommissionUserPageList, updateUserCommission, queryUserCommissionUserList } from '@/api/commission'
export default {
  name: 'CommissionMember',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:'',
        date: ['', '']
      },
      // 更改上级弹窗
      updateUserShow:false,
      oneForm:{
        updateCommissionUserId:''
      },
      updateUserList:[]
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      let userId = that.dataId
      let page = that.currentPage
      queryUserCommissionUserPageList({ webCommissionSearchStr: searchName, startDate: startDate, endDate: endDate, userId: userId,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    /* 更改上级弹窗-打开弹窗操作 */
    updateUserOpenBtn (dataId) {
      this.dataId = dataId
      let that = this
      queryUserCommissionUserList({ userId: dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.updateUserList = data;
          that.updateUserShow = true;
        }else{
          that.$message.error(res.msg);
        }
      })
    },
    // 更改上级弹窗-保存操作
    saveBtn(){
      var that = this
      var dataId = that.dataId
      var updateCommissionUserId = that.oneForm.updateCommissionUserId
      if (updateCommissionUserId === '') {
        this.$message.error('请选择分销员')
        return false
      }
      let passData = {
        userId: dataId, updateCommissionUserId: updateCommissionUserId
      }
      that.fullscreenLoading = true;
      updateUserCommission(passData).then((res) => {
        that.fullscreenLoading = false;
        if(res.errorCode == "0000"){
          that.$message.success(res.msg);
          that.oneForm.updateCommissionUserId = '';
          that.updateUserShow = false;
          that.currentPage = 1;
          that.getInfoList();
        }
        if(res.errorCode == "1001"){
          that.$message.error(res.msg);
        }
      })
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/commission/PromoteUsers.vue